/*

FILE: carousels.js
DESCRIPTION: Render carousels and handle functionality
AUTHOR(S): R.J. LaCount

*/
import { Splide, SplideSlide } from '@splidejs/splide';

const initSplideCarousels = (splideCarousels) => {
    var elms = document.getElementsByClassName( 'splide' );

    for ( var i = 0; i < elms.length; i++ ) {
        const imageCarousel = elms[ i ].classList.contains('image-carousel');
        const mobileOnly = elms[ i ].classList.contains('mobile-only');

        if (mobileOnly) {
            new Splide( elms[ i ], {
                mediaQuery: 'min',
                breakpoints: {
                    1080: {
                        destroy: true,
                    },
                },
                type   : 'loop',
                perPage: 1,
                focus  : 'center',
                padding: {
                    left : '10%',
                    right: '10%',
                },
                gap: '10px',
                pagination: true,
                arrows: true,
                autoplay: true,
            },).mount();
        } else if (imageCarousel) {
            new Splide( elms[ i ], {
                type   : 'loop',
                perPage    : 3,
                perMove: 3,
                updateOnMove: true,
                breakpoints: {
                    1024: {
                        perPage: 1,
                        perMove: 1,
                        padding: '15%',
                    },
                    725: {
                        type   : 'loop',
                        padding: '20%',
                    },
                }
            },).mount();
        } else {
            new Splide( elms[ i ], {
                perPage: 2,
                perMove: 1,
                breakpoints: {
                    1024: {
                        perPage: 1,
                    },
                }
            },).mount();
        }
    }
}

export { initSplideCarousels };
